const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.afterFormSubmit();
        this.popupClose();
    },

    afterFormSubmit: (
        sentClass = 'form-is-sent',
        bodyClass = 'body__overlay',
        contactClass = 'contact__overlay'
    ) => {
        document.addEventListener('wpcf7mailsent', () => {
            // const formId = e.detail.id;
            $('.js-cf7-holder').addClass(sentClass);
            $('body').addClass(bodyClass);
            $('.contact').addClass(contactClass);
    
            setTimeout(() => {
                $('.js-cf7-holder').removeClass(sentClass);
                $('body').removeClass(bodyClass);
                $('.contact').removeClass(contactClass);
            }, 5000);
        }, false);
    },

    popupClose: (
        sentClass = 'form-is-sent',
        bodyClass = 'body__overlay',
        contactClass = 'contact__overlay'
    ) => {
        $('.thank-you__close').on('click', function() {
            $('.js-cf7-holder').removeClass(sentClass);
            $('body').removeClass(bodyClass);
            $('.contact').removeClass(contactClass);
        });
    }
}

export default _this;